<template>
  <el-select
    class="serviceGroup-selector"
    :value="serviceGroupId"
    @input="handleChangeServiceGroup"
    filterable
    :disabled="disabled"
    placeholder="เลือกทั้งหมด"
    clearable
  >
    <el-option
      v-for="item in serviceGroupOptions"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
      <div class="serviceGroup-option">
        <img class="icon" :src="item.iconUrl" />
        <div class="name">{{ item.name }}</div>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import { Select, Option } from "element-ui";

export default {
  components: {
    "el-select": Select,
    "el-option": Option
  },
  props: ["value", "disabled"],
  data() {
    const serviceGroups = [];

    return {
      serviceGroups
    };
  },
  computed: {
    serviceGroupOptions() {
      return this.serviceGroups;
    },
    serviceGroupId() {
      if (!this.value) {
        return null;
      }

      return this.value.id;
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupServiceGroups();
    },
    async setupServiceGroups() {
      this.serviceGroups = await this.fetchServiceGroups();
    },
    async fetchServiceGroups() {
      const response = await baanRueJaiClient.admin.subscriptions.serviceCategories.list();

      return response.data.result.map(item => {
        return {
          id: item.id,
          name: item.name,
          iconUrl: item.icon,
          serviceCount: item.service_ids.length
        };
      });
    },
    handleChangeServiceGroup(serviceGroupId) {
      const serviceGroup = this.serviceGroups.find(
        serviceGroup => serviceGroup.id === serviceGroupId
      );

      this.$emit("input", serviceGroup);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.serviceGroup-selector {
  width: 100%;
}

.serviceGroup-option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .icon {
    margin-right: 20px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/lib/components/ServiceGroupSelector.vue